let api_domain;
if (process.env.REACT_APP_MIA_BACKEND_URL) {
  api_domain = process.env.REACT_APP_MIA_BACKEND_URL;
} else if (process.env.REACT_APP_NODE_ENV === 'production') {
  api_domain = 'https://mia.wihuri.fi/api';
} else if (process.env.REACT_APP_NODE_ENV === 'staging') {
  api_domain = 'https://miatest.wihuri.fi/api';
} else {
  api_domain = 'http://localhost:9000/api';
}

export const API_ROOT = `${api_domain}/`;



// WEBPACK FOOTER //
// ./src/api/constants.js